import { render } from "./DuyfkenView.vue?vue&type=template&id=48193e3c&scoped=true"
import script from "./DuyfkenView.vue?vue&type=script&lang=js"
export * from "./DuyfkenView.vue?vue&type=script&lang=js"

import "./DuyfkenView.vue?vue&type=style&index=0&id=48193e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48193e3c"]])

export default __exports__